import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { LangProvider } from "./lib/lang";
import Header from "./components/Header";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesIndex from "./pages/ServicesIndex";
import ServiceDetail from "./pages/ServiceDetail";
import FaqPage from "./pages/FaqPage";
import ApplyPage from "./pages/ApplyPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import IntakePage from "./pages/IntakePage";
import { DashboardHome, OrderDetail, RequestsList, NewRequest } from "./pages/Dashboard";
import AdminPage from "./pages/AdminPage";
import TermsPage from "./pages/TermsPage";
import WilhelmPage from "./pages/WilhelmPage";
import NotFound from "./pages/NotFound";
import ChatWidget from "./components/ChatWidget";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/es" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/es/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/es/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/es/services/:slug" element={<ServiceDetail />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/es/faq" element={<FaqPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/es/apply" element={<ApplyPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/intake/:orderId" element={<IntakePage />} />
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/dashboard/orders/:orderId" element={<OrderDetail />} />
            <Route path="/dashboard/requests" element={<RequestsList />} />
            <Route path="/dashboard/requests/new" element={<NewRequest />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/es/terms" element={<TermsPage />} />
            <Route path="/wilhelm" element={<WilhelmPage />} />
            <Route path="/wilhelm-noriega" element={<WilhelmPage />} />
            <Route path="/es/wilhelm" element={<WilhelmPage />} />
            <Route path="/es/wilhelm-noriega" element={<WilhelmPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <ChatWidget />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
